export default __webpack_public_path__ + "static/toolpooldark-8afa4dec58875c5ddfa1fac09ed2aeb0.png";